import { render, staticRenderFns } from "./BookingAlertTalentAttendanceConfirmation.vue?vue&type=template&id=639c76f6"
import script from "./BookingAlertTalentAttendanceConfirmation.vue?vue&type=script&lang=js"
export * from "./BookingAlertTalentAttendanceConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports